export function switchTheme() {
  return {
    type: '@user/SWITCH_THEME',
  }
}

export function toggleBar() {
  return {
    type: '@user/EXPAND_BAR',
  }
}

export function changeEmissora(emissora) {
  return {
    type: '@user/UPDATE_SELECTED_EMISSORA',
    payload: { emissora },
  }
}

export function updateFiltro(filtro) {
  return {
    type: '@user/UPDATE_FILTRO',
    payload: { filtro },
  }
}

export function updateCurrentDate(currentDate) {
  return {
    type: '@user/CURRENT_DATE',
    payload: { currentDate },
  }
}

export function updateDados({ nome, avatar_url: avatarURL }) {
  return {
    type: '@user/UPDATE_PROFILE_NOME',
    payload: { nome, avatarURL },
  }
}
